<template>
    <SelectField
        v-model="modelValue"
        v-model:options="campaignOptions"
        name="campaign"
        label="campaign"
        help="help_campaign"
        :required="true"
        :on-search="loadCampaignOptions"
    />
</template>

<script setup lang="ts">
import SelectField from '@src/components/SelectField.vue'
import { Campaign, Platform } from '@src/types'
import { getCampaigns } from '@src/utils/api/campaigns'
import { onMounted, Ref, ref, toRefs } from 'vue'

const props = defineProps<{
    modelValue: Ref<unknown>
    platform: Ref<Platform>
    language: string
}>()

const { platform, language, modelValue } = toRefs(props)

const campaignOptions = ref<{ value: string; label: string }[]>([])

const loadCampaignOptions = async (search: string) => {
    const request = await getCampaigns({
        'filter[search]': search,
        'filter[platform_name_exact]': platform.value.platform_name ?? '',
        'filter[language]': language.value,
    })

    campaignOptions.value = request.data.asset_variations.map(
        (campaign: Campaign) => {
            return {
                value: campaign.asset_var_uid as string,
                label:
                    campaign.asset_title + ' (' + campaign.platform_name + ')',
            }
        }
    )
}

onMounted(() => {
    loadCampaignOptions('')
})
</script>
